import constants from '../../../ahm-constants';
import defaultFbImage from '../../../images/default-fb.jpg';
import defaultTwImage from '../../images/default-tw.jpg';
import Head from '../../../../utils/head';

const description =
  'Simple, smart and affordable health cover for the things you’ll actually use. Hospital, choosable extras and more. Join online.';
const titleComplete = 'Cheap Private Health Insurance - ahm health insurance';

const AppHead = () => (
  <Head titleTemplate={constants.PAGE_TITLE_TEMPLATE}>
    <title>Cheap private health insurance</title>
    <link rel="manifest" href="/manifest.json" />
    <link rel="icon" href="/favicon.ico" />
    <meta charSet="utf-8" />
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="author" content="ahm" />
    <meta name="description" content={description} />
    <meta name="format-detection" content="telephone=no" />
    <meta name="google-site-verification" content="N8UjbrP3WOzHMMt-IJqzGWSr8J_Eza6qpeqs42LmlIk" />
    <meta name="og:description" content={description} />
    <meta name="og:image" content={defaultFbImage.src} />
    <meta name="og:site_name" content="ahm health insurance" />
    <meta name="og:title" content={titleComplete} />
    <meta name="og:type" content="website" />
    <meta name="theme-color" content="#000000" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:creator" content="@ahmhealth" />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image:src" content={defaultTwImage.src} />
    <meta name="twitter:site" content="@ahmhealth" />
    <meta name="twitter:title" content={titleComplete} />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Head>
);

export default AppHead;
